import {
  Box,
  Divider,
  Heading,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';

import { Button, Link, PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';
import { ZmyleLinks } from 'utils/paths';

export const PerformanceSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const {
    title,
    subtitle,
    description,
    feesRate,
    feesFixed,
    feesDescription,
    features,
    joinNetworkText,
    registerButton,
  } = content.performance;

  return (
    <PageContainer bg="gray.50">
      <PageContent direction={['column', 'column', 'row']}>
        <Stack
          direction={['column', 'column', 'column', 'row']}
          alignItems="center"
          justifyContent="center"
          h="full"
          w="full"
          spacing="1.5rem"
          fontSize="1.125rem"
        >
          <Stack
            direction={['column', 'column', 'row']}
            alignItems="center"
            justifyContent="center"
            spacing="1.5rem"
          >
            <VStack
              align="flex-start"
              spacing="5rem"
              w="full"
              minW={['unset', 'unset', '21rem']}
            >
              <VStack align="flex-start" spacing="1rem">
                <Heading fontSize="1.25rem" color="store.primary">
                  {title}
                </Heading>

                <Heading fontSize="1.5rem">{subtitle}</Heading>

                <Text fontSize="1.125rem">{description}</Text>
              </VStack>
            </VStack>

            <VStack
              w="full"
              h="20.875rem"
              minW="17.875rem"
              maxW="20.875rem"
              maxH="20.875rem"
              bgGradient="linear(to-tr, store.secondary, store.primary)"
              rounded="lg"
              shadow="2xl"
              align="center"
              justify="space-between"
              color="white"
              pb="1rem"
            >
              <span />

              <VStack align="center" justify="center">
                <Heading fontSize="5rem">{feesRate}</Heading>

                <Text>{feesFixed}</Text>
              </VStack>

              <VStack spacing="1.25rem">
                <Box w="70%">
                  <Divider borderColor="white" />
                </Box>

                <Text
                  fontSize="0.75rem"
                  textAlign="center"
                  lineHeight="1rem"
                  px="0.5rem"
                >
                  {feesDescription}
                </Text>
              </VStack>
            </VStack>
          </Stack>

          <Stack
            direction={['column', 'column', 'row']}
            alignItems="center"
            justifyContent="center"
            spacing="1.5rem"
          >
            <UnorderedList
              w={['unset', 'unset', 'unset', 'full']}
              minW={['unset', 'unset', '21rem']}
              spacing={0}
              pl="0.5rem"
            >
              {features.map(({ title: feature }) => (
                <ListItem key={feature}>{feature}</ListItem>
              ))}
            </UnorderedList>

            <VStack
              spacing="2.5rem"
              w="full"
              minW={['unset', 'unset', '20rem']}
            >
              <Text>{joinNetworkText}</Text>

              <Link href={ZmyleLinks.SIGN_UP} isExternal>
                <Button variant="store">{registerButton}</Button>
              </Link>
            </VStack>
          </Stack>
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
